export default __webpack_public_path__ + "static/media/screen5.2dcc3fe1.png";